/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ZipLookupResponse } from './ZipLookupResponse';
import {
    ZipLookupResponseFromJSON,
    ZipLookupResponseFromJSONTyped,
    ZipLookupResponseToJSON,
} from './ZipLookupResponse';

/**
 * 
 * @export
 * @interface LookupZipOptions200Response
 */
export interface LookupZipOptions200Response {
    /**
     * 
     * @type {ZipLookupResponse}
     * @memberof LookupZipOptions200Response
     */
    data?: ZipLookupResponse;
}

/**
 * Check if a given object implements the LookupZipOptions200Response interface.
 */
export function instanceOfLookupZipOptions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LookupZipOptions200ResponseFromJSON(json: any): LookupZipOptions200Response {
    return LookupZipOptions200ResponseFromJSONTyped(json, false);
}

export function LookupZipOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupZipOptions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ZipLookupResponseFromJSON(json['data']),
    };
}

export function LookupZipOptions200ResponseToJSON(value?: LookupZipOptions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ZipLookupResponseToJSON(value.data),
    };
}

